export const PRODUCT_TABS = {
  DETAIL: 'components.productTabs.tabs.DETAIL',
  BALL: 'components.productTabs.tabs.BALL',
  CERTIFICATE: 'components.productTabs.tabs.CERTIFICATE',
};

export const TABS_BUTTON_SKELETON_HEIGHT = 40;

export const CERTIFICATE_HEIGHT = 200;
